<h2 mat-dialog-title>Settings</h2>
<mat-dialog-content class="mat-typography">
  <p>random settings</p>
  <form class="example-form">
    <mat-form-field class="example-full-width">
      <mat-label>Count</mat-label>
      <input name="count" matInput placeholder="" [(ngModel)]="randomSettings.count">
    </mat-form-field>
    &nbsp;
    <mat-form-field class="example-full-width">
      <mat-label>Min length</mat-label>
      <input name="min_length" matInput placeholder="" [(ngModel)]="randomSettings.min_length">
    </mat-form-field>
    &nbsp;
    <mat-form-field class="example-full-width">
      <mat-label>Max length</mat-label>
      <input name="max_length" matInput placeholder="" [(ngModel)]="randomSettings.max_length">
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button (click)="onSave()" mat-raised-button color="primary" cdkFocusInitial>Save</button>
</mat-dialog-actions>
